export default function DetailRow({label, value, valueColor='text-gray-900'}) {
    return (
        <div className="flex flex-row gap-4 py-2 border-t border-gray-100">
            <span className="text-gray-500 flex-1 text-md">{label}</span>
            <span className={"flex-[3] " + valueColor}>{value}</span>
        </div>
    )
}